import { createFileRoute } from "@tanstack/react-router";

import { RdcNotificationMappingsRoute } from "../../containers/RdcNotificationMappingsRoute";

export const Route = createFileRoute("/_layout-nosidebar/rdc-notification-mappings")({
    component: RdcNotificationMappingsPage,
});

function RdcNotificationMappingsPage() {
    return <RdcNotificationMappingsRoute />;
}
